import { useState } from 'react';

// Constellation
import { Button } from '@zillow/constellation';

// constants
import { HeaderTitles } from '../../constants';

// interfaces
import type { HeaderSubNavLink } from '../../interfaces/HeaderSubNavLink';

// styles
import {
  StyledButtonContainer,
  StyledContainer,
  StyledHeaderSubNav,
  StyledSubNavLink,
  StyledSubNavTabTitle,
  StyledSubTab,
  StyledSubTabContainer,
  StyledTab,
} from './style';

interface Props {
  headerSubNavLinks: Array<HeaderSubNavLink>;
  isZrmHomepage?: boolean;
  isStickyHeaderNavActive?: boolean;
}

interface Tab {
  title: string;
  isActive?: boolean;
}

const SubNav = ({ headerSubNavLinks, isZrmHomepage, isStickyHeaderNavActive }: Props) => {
  const [activeDropdown, setActiveDropdown] = useState('');
  const postListingTabTitle = HeaderTitles.postAListing;
  const postListingSubNavLink = headerSubNavLinks.find((subNavLink) => subNavLink.title === postListingTabTitle);
  const showPostListingLinkAsButton = isZrmHomepage && isStickyHeaderNavActive;

  if (showPostListingLinkAsButton) {
    // Remove post listing link from SubNav links array so that it won't be rendered as a tab.
    headerSubNavLinks = headerSubNavLinks.filter((subNavLink) => subNavLink.title !== postListingTabTitle);
  }

  const handleMouseOver = (tab: Tab) => {
    setActiveDropdown(tab.title);
  };

  const handleMouseOut = () => {
    setActiveDropdown('');
  };

  return (
    <StyledHeaderSubNav data-testid="HeaderSubNav">
      <StyledContainer>
        {headerSubNavLinks.map((tab) => (
          <StyledTab
            isActive={tab.isActive}
            onMouseOver={() => handleMouseOver(tab)}
            onMouseOut={handleMouseOut}
            key={tab.title}
          >
            {tab.isActive && (tab.subTitles || []).every(({ isActive }) => !isActive) ? (
              <StyledSubNavTabTitle isActive={tab.isActive}>{tab.title}</StyledSubNavTabTitle>
            ) : (
              <StyledSubNavLink href={tab.url}>
                <StyledSubNavTabTitle isActive={tab.isActive}>{tab.title}</StyledSubNavTabTitle>
              </StyledSubNavLink>
            )}
            {tab.subTitles && (
              <StyledSubTabContainer isVisible={activeDropdown === tab.title}>
                {tab.subTitles.map((subTab) => (
                  <StyledSubTab key={subTab.title}>
                    {subTab.isActive ? (
                      <StyledSubNavTabTitle isActive={subTab.isActive}>{subTab.title}</StyledSubNavTabTitle>
                    ) : (
                      <StyledSubNavLink href={subTab.url}>{subTab.title}</StyledSubNavLink>
                    )}
                  </StyledSubTab>
                ))}
              </StyledSubTabContainer>
            )}
          </StyledTab>
        ))}
        {showPostListingLinkAsButton && (
          <StyledButtonContainer>
            <Button
              size="sm"
              marginTop="xs"
              marginRight="sm"
              as="a"
              href={postListingSubNavLink?.url}
              buttonType="primary"
            >
              Post a Listing
            </Button>
          </StyledButtonContainer>
        )}
      </StyledContainer>
    </StyledHeaderSubNav>
  );
};

export default SubNav;
